import { Box, MenuItem, Select, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { FunctionComponent } from 'react';
import { useAppTranslate } from '../../../../core/hooks';
import { getResolutionConfig, getTimespanConfig, TimespanConfigs } from '../../config';
import { ChartSettingsInteractionModel } from '../../hooks';

interface Props {
  chartSettingsInteraction: ChartSettingsInteractionModel;
}

export const StatisticsTableChartOptions: FunctionComponent<Props> = ({ chartSettingsInteraction }) => {
  const { chartSettings, setResolution, setTimespan } = chartSettingsInteraction;
  const translate = useAppTranslate();
  const allowedResolutionsConfigs = getTimespanConfig(chartSettings.timespan).allowedResolutions.map(resolution => getResolutionConfig(resolution));

  return <Box sx={{ display: 'flex', justifyContent: 'end', gap: 2, mb: 2 }}>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
      }}
    >
      <Typography
        variant={'caption'}
        sx={{ marginRight: '4px' }}
      >{translate('tableHeaders.timespan')}</Typography>
      <Select
        value={chartSettings.timespan}
        sx={{ ml: 2 }}
        size={'small'}
        inputProps={{
          sx: {
            background: '#EDF3F9',
            fontSize: '13px',
            border: 0,
            '& ~ .MuiOutlinedInput-notchedOutline': {
              border: 0,
            },
          },
        }}
      >
        {TimespanConfigs.map(value => {
          return <MenuItem
            value={value.value}
            key={value.value}
            onClick={() => setTimespan(value.value)}
            sx={{ fontSize: '13px' }}
          >{value.label}</MenuItem>;
        })}
      </Select>
    </Box>
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Typography
        variant={'caption'}
        sx={{ marginRight: '4px' }}
      >{translate('tableHeaders.resolution')}</Typography>
      <ToggleButtonGroup
        value={chartSettings.resolution}
        size={'small'}
      >
        {allowedResolutionsConfigs.map(value => {
          return <ToggleButton
            value={value.value}
            key={value.value}
            onClick={() => setResolution(value.value)}
            disableRipple
          >{value.label}</ToggleButton>;
        })}
      </ToggleButtonGroup>
    </Box>
  </Box>;
};
